import {inject, Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {AuthService, defaultPath} from "./auth.service";
import {catchError, map, switchMap, take} from "rxjs/operators";
import {Observable, of, from} from "rxjs";

@Injectable()
export class AuthGuardService implements CanActivate {
    private router = inject(Router);
    private authService = inject(AuthService);

    private getResolvedUrl(state: RouterStateSnapshot): string {
        return state.url.split(/[?#]/)[0];
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.authService.isAuthenticated$().pipe(
            take(1),
            switchMap(isAuthenticated => {
                if (isAuthenticated) {
                    this.authService.lastAuthenticatedPath = this.getResolvedUrl(state) || defaultPath;
                    return of(true);
                }

                return from(this.authService.refresh()).pipe(
                    map(() => {
                        this.authService.lastAuthenticatedPath = this.getResolvedUrl(state) || defaultPath;
                        return true;
                    }),
                    catchError(() => {
                        const isAuthForm = [
                            'sign-in',
                            'reset-password',
                            'register',
                            'change-password/:recoveryCode',
                        ].includes(route.routeConfig?.path || defaultPath);

                        if (!isAuthForm) {
                            return of(this.router.createUrlTree(['/auth/sign-in'], {
                                queryParams: {returnUrl: state.url}
                            }));
                        }

                        return of(true);
                    })
                );
            }),
            catchError(() => {
                return of(this.router.createUrlTree(['/error']));
            })
        );
    }
}
